import { render, staticRenderFns } from "./RegisterJWT.vue?vue&type=template&id=c2406d0a&scoped=true&"
import script from "./RegisterJWT.vue?vue&type=script&lang=js&"
export * from "./RegisterJWT.vue?vue&type=script&lang=js&"
import style0 from "./RegisterJWT.vue?vue&type=style&index=0&id=c2406d0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2406d0a",
  null
  
)

export default component.exports